import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HeaderStateStore } from '../../state/header.state';
import { UserInitialsIconComponent } from '../user-initials-icon/user-initials-icon.component';
import { AuthenticationStateStore } from '@unicup-ticketing/auth';
import { ButtonComponent } from '@unicup-ticketing/ui';
import { CombinedLogoComponent } from '../combined-logo/combined-logo.component';
import { NavigationStateStore } from '../../navigation/nav-items.state';

@Component({
  selector: 'ticketing-header',
  imports: [
    CommonModule,
    RouterLink,
    UserInitialsIconComponent,
    ButtonComponent,
    CombinedLogoComponent,
    RouterLinkActive,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly navItems = inject(NavigationStateStore).items;
  readonly hero = inject(HeaderStateStore).hero;

  private readonly authState = inject(AuthenticationStateStore);
  readonly isAuthenticated = this.authState.isAuthenticated;

  readonly user = computed(() => {
    const idToken = this.authState.idToken();
    if (idToken) {
      return {
        givenName: idToken.user.givenName,
        surname: idToken.user.surname,
      };
    }
    return undefined;
  });
}
